import Rabbit from "crypto-js/rabbit";
import CryptoJS from "crypto-js";

export function decrypt(encryptedMessage: string, secret: string) {
  return Rabbit.decrypt(encryptedMessage, secret).toString(CryptoJS.enc.Utf8);
}
